import React from 'react';
import Footer from './common/Footer';

const HowToUse = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 opacity-10">
        <img
          src="/images/imr-logo.png"
          alt="IMR Logo Background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex-grow flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
        {/* Logo Section */}
        <div className="w-full max-w-lg mb-8">
          <div className="flex flex-col items-center relative z-10">
            <img
              src="/images/imr-logo.png"
              alt="IMR Logo"
              className="h-32 w-auto mb-4"
            />
            <h1 className="text-center text-2xl font-bold text-yellow-500">
              DEFENCE INDUSTRY DIRECTORY
            </h1>
          </div>
        </div>

        {/* How to Use Content */}
        <div className="w-full max-w-4xl relative z-10">
          <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-gray-700 backdrop-blur-sm text-gray-300">
            <h2 className="text-2xl font-bold text-yellow-500 mb-6">How to Use the Directory Online</h2>
            
            <p className="mb-6">
              This directory is designed to help users efficiently discover key companies, products, and services 
              in the defense industry. The platform offers intuitive search options and clear navigation to ensure 
              a seamless experience for both industry professionals and newcomers.
            </p>

            <div className="space-y-8">
              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-4">Search Options</h3>
                <p className="mb-3">You can search the directory using:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <span className="font-medium text-gray-200">Company Name:</span> Enter the part or full name 
                    of the company you are looking for to quickly access its profile.
                  </li>
                  <li>
                    <span className="font-medium text-gray-200">Products & Services:</span> Browse by products, and 
                    services. Enter part or full product name.
                  </li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-4">Viewing Search Results</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Search results are displayed as a list of company names.</li>
                  <li>Click on any company name to view its profile. Profiles are available in two formats:</li>
                  <ul className="list-none pl-6 mt-2 space-y-2">
                    <li className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <div>
                        <span className="font-medium text-gray-200">Premium Profile:</span> For companies that have 
                        provided detailed information, offering comprehensive insights, extended contact details, 
                        and in-depth data.
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <div>
                        <span className="font-medium text-gray-200">Standard Profile:</span> For companies with 
                        limited information, including essential details such as company name, contact information, 
                        website, and a summary of products and services.
                      </div>
                    </li>
                  </ul>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-4">Downloading and Printing</h3>
                <ul className="list-disc pl-6">
                  <li>You may download or print any company profile for your records or reference.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-4">Tips for Best Results</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Use specific keywords or filter by relevant categories to narrow down your search.</li>
                  <li>Always verify company details directly before making business decisions or establishing contact.</li>
                </ul>
              </section>

              <p className="mt-8 text-gray-300">
                If you need further assistance, please contact our support team at{' '}
                <a href="mailto:directory@defencepartners.in" className="text-yellow-500 hover:text-yellow-400 transition-colors duration-200">
                  directory@defencepartners.in
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HowToUse;
